import type { IconData } from '@stacksjs/iconify-core'

export const pacmanFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5c7.212 0 13.631-3.395 17.747-8.667c1.283-1.645.684-3.882-.911-4.898L26.794 24l14.042-8.935c1.596-1.016 2.194-3.253.91-4.898C37.632 4.895 31.213 1.5 24 1.5\"/><path fill=\"#2859c5\" d=\"M20.5 11a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pacmanFlat
